import React from "react";
import { LearningRecordSimulation, SimulationAssessmentReport, SimulationTranscript } from "src/types/coaching/learners";
import { Simulation } from "src/types/coaching/simulation";

export interface SimulationReportContextProps {
  // eslint-disable-next-line no-unused-vars
  showCallRecording?: boolean; 
  toggleCallRecording?: () => void;
  simulation?: Simulation;
  learners?: any[];

  fetchingTranscripts?: boolean;

  transcripts?: SimulationTranscript[];

  fetchTranscripts?: (attempt?: any) => void;
  learningRecord?: LearningRecordSimulation;
}

export const SimulationReportContext = React.createContext<SimulationReportContextProps>({
  
});
